import type { Ctx } from "../../types";
import { FormAction, invalidate, setQueryParams } from "gg-wf-scripts";
import { invokeApi, parse } from "../_helpers";
import { school_schema } from "./_schema";

export const update_school: FormAction<Ctx> = async (
  { sb },
  formData,
  params
) => {
  const school_id = params.get("id");
  if (!school_id) return { ok: false, error: "Missing id in URL" };

  const parsed = parse(school_schema, formData);
  if (!parsed.ok) return parsed;

  const result = await invokeApi(sb, `api/schools/${school_id}`, {
    method: "PUT",
    body: parsed.data,
  });
  if (!result.ok) return result;
  invalidate("schools");
  setQueryParams([{ key: "modal", value: "view" }]);
  return result;
};
